"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.deserializeTransaction = exports.serializeTransaction = exports.deserializeAccount = exports.serializeAccount = void 0;
const bignumber_js_1 = __importDefault(require("bignumber.js"));
const serializer_1 = require("./families/algorand/serializer");
const serializer_2 = require("./families/bitcoin/serializer");
const serializer_3 = require("./families/cosmos/serializer");
const serializer_4 = require("./families/crypto_org/serializer");
const serializer_5 = require("./families/ethereum/serializer");
const serializer_6 = require("./families/polkadot/serializer");
const serializer_7 = require("./families/ripple/serializer");
const serializer_8 = require("./families/stellar/serializer");
const serializer_9 = require("./families/tezos/serializer");
const serializer_10 = require("./families/tron/serializer");
const types_1 = __importDefault(require("./families/types"));
/**
 * Serialize an [[Account]] object in order to send it over JSON-RPC protocol
 * to the Ledger Live platform
 * @param account - The account object to serialize
 *
 * @returns The raw representation of the provided account object
 */
function serializeAccount({ id, name, address, currency, balance, spendableBalance, blockHeight, lastSyncDate, }) {
    return {
        id,
        name,
        address,
        currency,
        balance: balance.toString(),
        spendableBalance: spendableBalance.toString(),
        blockHeight,
        lastSyncDate: lastSyncDate.toISOString(),
    };
}
exports.serializeAccount = serializeAccount;
/**
 * Deserialize a [[RawAccount]] object after it has been received over JSON-RPC
 * protocol from the Ledger Live platform
 * @param rawAccount - The raw account representation to deserialize
 *
 * @returns The object account of the provided raw account representation
 */
function deserializeAccount({ id, name, address, currency, balance, spendableBalance, blockHeight, lastSyncDate, }) {
    return {
        id,
        name,
        address,
        currency,
        balance: new bignumber_js_1.default(balance),
        spendableBalance: new bignumber_js_1.default(spendableBalance),
        blockHeight,
        lastSyncDate: new Date(lastSyncDate),
    };
}
exports.deserializeAccount = deserializeAccount;
/**
 * Serialize an [[Transaction]] object in order to send it over JSON-RPC
 * protocol to the Ledger Live platform
 * @param transaction - The transaction object to serialize
 *
 * @returns The raw representation of the provided transaction object
 */
function serializeTransaction(transaction) {
    switch (transaction.family) {
        case types_1.default.ETHEREUM:
            return (0, serializer_5.serializeEthereumTransaction)(transaction);
        case types_1.default.BITCOIN:
            return (0, serializer_2.serializeBitcoinTransaction)(transaction);
        case types_1.default.ALGORAND:
            return (0, serializer_1.serializeAlgorandTransaction)(transaction);
        case types_1.default.CRYPTO_ORG:
            return (0, serializer_4.serializeCryptoOrgTransaction)(transaction);
        case types_1.default.RIPPLE:
            return (0, serializer_7.serializeRippleTransaction)(transaction);
        case types_1.default.COSMOS:
            return (0, serializer_3.serializeCosmosTransaction)(transaction);
        case types_1.default.TEZOS:
            return (0, serializer_9.serializeTezosTransaction)(transaction);
        case types_1.default.POLKADOT:
            return (0, serializer_6.serializePolkadotTransaction)(transaction);
        case types_1.default.STELLAR:
            return (0, serializer_8.serializeStellarTransaction)(transaction);
        case types_1.default.TRON:
            return (0, serializer_10.serializeTronTransaction)(transaction);
        default:
            throw new Error("Can't serialize transaction: family not supported");
    }
}
exports.serializeTransaction = serializeTransaction;
/**
 * Deserialize a [[RawTransaction]] object after it has been received over
 * JSON-RPC protocol from the Ledger Live platform
 * @param rawTransaction - The raw transaction representation to deserialize
 *
 * @returns The object transaction of the provided raw transaction representation
 */
function deserializeTransaction(rawTransaction) {
    switch (rawTransaction.family) {
        case types_1.default.ETHEREUM:
            return (0, serializer_5.deserializeEthereumTransaction)(rawTransaction);
        case types_1.default.BITCOIN:
            return (0, serializer_2.deserializeBitcoinTransaction)(rawTransaction);
        case types_1.default.ALGORAND:
            return (0, serializer_1.deserializeAlgorandTransaction)(rawTransaction);
        case types_1.default.CRYPTO_ORG:
            return (0, serializer_4.deserializeCryptoOrgTransaction)(rawTransaction);
        case types_1.default.RIPPLE:
            return (0, serializer_7.deserializeRippleTransaction)(rawTransaction);
        case types_1.default.COSMOS:
            return (0, serializer_3.deserializeCosmosTransaction)(rawTransaction);
        case types_1.default.TEZOS:
            return (0, serializer_9.deserializeTezosTransaction)(rawTransaction);
        case types_1.default.POLKADOT:
            return (0, serializer_6.deserializePolkadotTransaction)(rawTransaction);
        case types_1.default.STELLAR:
            return (0, serializer_8.deserializeStellarTransaction)(rawTransaction);
        case types_1.default.TRON:
            return (0, serializer_10.deserializeTronTransaction)(rawTransaction);
        default:
            throw new Error("Can't deserialize transaction: family not supported");
    }
}
exports.deserializeTransaction = deserializeTransaction;
